/* eslint-disable */

import { useState } from "react";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import Currency from "../../../ui-components/currency/currency.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";

const PriceTile = ({ title, subtitle, equation, subunits }) => {
  return (
    <div className="flex flex-col p-4 bg-color-dark-background-secondary rounded-lg w-full max-w-sm">
      <div className="font-medium text-lg text-left w-full">{title}</div>
      <div className="font-medium text-xs text-color-dark-text-tertiary text-left">
        {subtitle}
      </div>
      <div className="w-full text-end text-color-dark-text-tertiary">
        {equation}
      </div>
      <div className="flex flex-col font-bold text-3xl text-right w-full items-end ">
        <Currency subunits={subunits} isStylised={true} />
      </div>
    </div>
  );
};

const NimbusFinanceStripePricing = () => {
  const [numberOfOrganisations, setNumberOfOrganisations] = useState(1);
  const [numberOfUsers, setNumberOfUsers] = useState(100);
  const [subunitsOfAverageSausage, setSubunitsOfAverageSausage] =
    useState(2000);

  const fixedMonthlyCharge = numberOfOrganisations * 200;
  const chargePerPayout =
    subunitsOfAverageSausage * numberOfUsers * 0.0025 + 10;
  const chargePerPayoutWithoutGrouping =
    numberOfUsers * (subunitsOfAverageSausage * 0.0025 + 10);
  return (
    <div className="flex flex-row h-full text-center gap-2 w-full">
      <div className="flex flex-col gap-2">
        <a href={"https://stripe.com/gb/connect/pricing"}>
          https://stripe.com/gb/connect/pricing
        </a>
        <RaindropInput
          label={"Number of Organisations"}
          value={numberOfOrganisations}
          onChange={(e) => setNumberOfOrganisations(e.target.value)}
          type="number"
          isShowLabel={true}
          icon={null}
        />
        <RaindropInput
          label={"Number of Users"}
          value={numberOfUsers}
          onChange={(e) => setNumberOfUsers(e.target.value)}
          type="number"
          isShowLabel={true}
          icon={null}
        />
        <RaindropInput
          label={"Subunits of Average Sausage"}
          value={subunitsOfAverageSausage}
          onChange={(e) => setSubunitsOfAverageSausage(e.target.value)}
          type="number"
          isShowLabel={true}
          icon={null}
          isFluid={true}
        />
      </div>
      <div className="flex flex-col gap-2 w-full items-center">
        <PriceTile
          title={"Fixed Monthly charge"}
          subtitle={"£2 GBP per monthly active account"}
          equation={`£2 x ${numberOfOrganisations} =`}
          subunits={fixedMonthlyCharge}
        />
        <div className="flex flex-row gap-2">
          <PriceTile
            title={"Charge per Payout"}
            subtitle={"0.25% + 10p per payout sent"}
            equation={`${subunitsOfAverageSausage} x ${numberOfUsers} x 0.0025 + 10 =`}
            subunits={chargePerPayout}
          />
          <PriceTile
            title={"Charge per Payout (without grouping)"}
            subtitle={"0.25% + 10p per payout sent"}
            equation={`${numberOfUsers} x (${subunitsOfAverageSausage} x 0.0025 + 10) =`}
            subunits={chargePerPayoutWithoutGrouping}
          />
        </div>
        <div className="flex flex-row gap-2">
          <PriceTile
            title={"Total monthly charge"}
            subtitle={"The total amount you'd need to pay in a month."}
            equation={`${chargePerPayout} x ${numberOfOrganisations} + ${fixedMonthlyCharge} = `}
            subunits={
              chargePerPayout * numberOfOrganisations + fixedMonthlyCharge
            }
          />
          <PriceTile
            title={"Total monthly charge without Grouping"}
            subtitle={
              "The total amount you'd need to pay in a month if you don't group payouts."
            }
            equation={`${chargePerPayoutWithoutGrouping} x ${numberOfOrganisations} + ${fixedMonthlyCharge} = `}
            subunits={
              chargePerPayoutWithoutGrouping * numberOfOrganisations +
              fixedMonthlyCharge
            }
          />
        </div>
      </div>
    </div>
  );
};

export default NimbusFinanceStripePricing;
